export default defineNuxtPlugin(() => {
  const bus = useEventBus<string>("main");

  const listener = (event: string) => {
    if (event == "overlay:open") {
      // document.documentElement.classList.add("has-overlay");
      document.getElementById("__nuxt")?.classList.add("has-overlay");
    }
    if (event == "overlay:close") {
      // document.documentElement.classList.remove("has-overlay");
      document.getElementById("__nuxt")?.classList.remove("has-overlay");
    }
  };

  bus.on(listener);
});
